import * as Yup from 'yup';

const BIRTHDATE_PATTERN = /^\d{2}\/\d{2}\/\d{4}$/;
const MIN_YEAR = 1900;

export const normalizeBirthdate = (value: string | undefined | null): string => {
	const trimmed = (value ?? '').trim();

	return /^[\d/_\s]*$/.test(trimmed) && !/\d/.test(trimmed) ? '' : trimmed;
};

export const isValidBirthdate = (value: string): boolean => {
	if (!BIRTHDATE_PATTERN.test(value)) {
		return false;
	}

	const [day, month, year] = value.split('/').map(Number);
	const date = new Date(year, month - 1, day);

	if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
		return false;
	}

	return year >= MIN_YEAR && date.getTime() <= Date.now();
};

export const birthdateSchema = (isRequired: boolean, requiredMessage: string, invalidMessage: string) => {
	const base = Yup.string()
		.transform((value) => normalizeBirthdate(value))
		.test('birthdate-format', invalidMessage, (value) => !value || isValidBirthdate(value));

	return isRequired ? base.required(requiredMessage) : base.notRequired();
};
